import React from 'react';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { useTheme } from '@mui/material/styles';

// Modular SVG Icon Button component
// Sample invocation:
/* <SvgIconButton
  icon={GavelIcon}
  onClick={handleSettlementClick}
  tooltip="Settle Case - Not Yet Available"
  className="p-1 mr-0.5"
/> */ 
const SvgIconButton = ({ 
  icon: IconComponent, 
  onClick, 
  disabled = false, 
  tooltip, 
  className = 'p-1', 
  size = 'small',
  activeColor = 'text.secondary',
  hoverColor = 'primary.main',
  iconProps = {},
  sx,
  ...props 
}) => {
  const theme = useTheme();
  
  const buttonElement = (
    <IconButton
      className={className}
      onClick={onClick}
      disabled={disabled}
      size={size}
      {...props}
      sx={{
        color: activeColor,
        backgroundColor: 'transparent',
        padding: '8px',
        borderRadius: '4px',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        lineHeight: 0,
        '& .MuiSvgIcon-root': {
          strokeWidth: '0.5',
          display: 'block',
          ...iconProps.sx
        },
        '&:hover': {
          color: disabled ? theme.palette.grey[400] : hoverColor,
          backgroundColor: disabled ? 'transparent' : 'rgba(0, 0, 0, 0.04)',
          cursor: disabled ? 'not-allowed' : 'pointer',
          borderRadius: '4px'
        },
        '&.Mui-disabled': {
          color: theme.palette.grey[400],
          backgroundColor: 'transparent !important',
          cursor: 'not-allowed !important',
          '& .MuiSvgIcon-root': {
            color: theme.palette.grey[400],
            fill: 'currentColor',
            stroke: 'currentColor',
            strokeWidth: '0.5',
            display: 'block',
            ...iconProps.sx,
          },
        },
        ...sx,
      }}
    >
      <IconComponent fontSize="small" />
    </IconButton>
  );

  return (
    <Tooltip 
      title={tooltip}
      disableInteractive
      TransitionProps={{ style: { transitionDelay: '0ms' } }}
      slotProps={{
        popper: {
          sx: {
            marginTop: '-8px !important'
          }
        }
      }}
    >
      <span style={{ display: 'inline-flex', alignItems: 'center' }}>{buttonElement}</span>
    </Tooltip>
  );
};

export default SvgIconButton;
